import L from "leaflet";
import AOIPopup from "./Popups/AOIPopup";
import PipePopup from "./Popups/PipePopup";
import LeakPopup from "./Popups/LeakPopup";
import ReactDOMServer from "react-dom/server";

export const highlightFeature = (feature, layer) => {
  layer.on({
    click: (e) => {
      let content;
      switch (feature.object) {
        case "AOI":
          content = ReactDOMServer.renderToString(
            <AOIPopup feature={feature} />
          );
          break;
        case "PIPE":
          content = ReactDOMServer.renderToString(
            <PipePopup feature={feature} />
          );
          break;
        case "LEAK":
          content = ReactDOMServer.renderToString(
            <LeakPopup feature={feature} />
          );
          break;
        default:
          break;
      }
      L.popup({ className: "boundings-popup", closeButton: false })
        .setLatLng(e.latlng)
        .setContent(content)
        .openOn(layer._map);
    },
    mouseover: (e) => {
      const target = e.target;
      target.setStyle({
        color: "#E99F37",
        weight: 9,
        opacity: 1,
      });
    },
    mouseout: (e) => {
      const target = e.target;
      target.setStyle({
        color: "#3388ff",
        weight: 3,
        opacity: 1,
        fillOpacity: 0.2,
      });
    },
  });
};

export const canvasRenderer = L.canvas({
  tolerance: 12, // Increases invisible hitbox
});
